import styled from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

export const StyledInfoContainer = styled.div`
    margin: auto;
    max-width: 460px;
`;

export const StyledDot = styled.div`
    width: 8px;
    height: 8px;
    background: ${token('colors.blue600')};
    border-radius: 50%;
    margin-right: ${spaceMixin('sm')};
`;
